import React from 'react';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingTiers() {
  return <section id="pricing" className="py-24 bg-brand-lighter px-6 lg:px-8" data-id="element-197">
      <div className="max-w-5xl mx-auto" data-id="element-198">
        <div className="text-center mb-16" data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-4" data-id="element-200">
            Elegí tu nivel de aceleración
          </h2>
          <p className="text-xl text-brand-navy/70" data-id="element-201">
            Pago único. Acceso de por vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-202">
          {/* Tier 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 border border-brand-light shadow-soft flex flex-col" data-id="element-203">
            <h3 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-204">
              MEGAPACK AGENTE PRO
            </h3>
            <p className="text-brand-navy/60 text-sm mb-6 min-h-[40px]" data-id="element-205">
              Ideal para: corredores recién recibidos, sin cartera.
            </p>

            <div className="mb-8" data-id="element-206">
              <span className="text-brand-navy/40 line-through text-lg font-medium block mb-1" data-id="element-207">
                $34.000
              </span>
              <div className="flex items-baseline gap-1" data-id="element-208">
                <span className="text-4xl font-extrabold text-brand-navy" data-id="element-209">
                  $19.990
                </span>
                <span className="text-brand-navy/60 font-medium" data-id="element-210">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-211">
              <li className="flex items-start gap-3" data-id="element-212">
                <Check className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-213" />
                <span className="text-brand-navy/80 font-medium" data-id="element-214">
                  Los 6 Módulos del Sistema
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-215">
                <Check className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-216" />
                <span className="text-brand-navy/80 font-medium" data-id="element-217">
                  Los 4 Bonos de Acción Rápida
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-218">
                <Check className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-219" />
                <span className="text-brand-navy/80 font-medium" data-id="element-220">
                  Acceso de por vida y actualizaciones
                </span>
              </li>
            </ul>

            <a href="https://librofy-store.myshopify.com/cart/47909760106717:1" className="w-full py-4 rounded-xl font-bold text-brand-accent bg-brand-light hover:bg-blue-100 transition-colors border border-blue-200 text-center block" data-id="element-221">
              Operá como profesional
            </a>
          </motion.div>

          {/* Tier 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-navy rounded-3xl p-8 border-2 border-brand-accent shadow-soft-lg flex flex-col relative transform md:-translate-y-4" data-id="element-222">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-gold text-brand-navy px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-223">
              <Star className="w-4 h-4 fill-brand-navy" data-id="element-224" />
              MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold text-white mb-2 mt-2" data-id="element-225">
              MEGAPACK AGENTE PRO + ESCALADO DE CARTERA
            </h3>
            <p className="text-white/60 text-sm mb-6 min-h-[40px]" data-id="element-226">
              Ideal para: corredores que ya cerraron su primera venta y quieren
              escalar con el Kit Cartera Activa.
            </p>

            <div className="mb-8" data-id="element-227">
              <span className="text-white/40 line-through text-lg font-medium block mb-1" data-id="element-228">
                $45.000
              </span>
              <div className="flex items-baseline gap-1" data-id="element-229">
                <span className="text-4xl font-extrabold text-white" data-id="element-230">
                  $27.990
                </span>
                <span className="text-white/60 font-medium" data-id="element-231">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-232">
              <li className="flex items-start gap-3" data-id="element-233">
                <Check className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-234" />
                <span className="text-white/90 font-medium" data-id="element-235">
                  Todo lo del Megapack Agente PRO
                </span>
              </li>
              <li className="flex items-start gap-3 bg-white/10 p-3 rounded-lg" data-id="element-236">
                <Check className="w-5 h-5 text-brand-green shrink-0 mt-0.5" data-id="element-237" />
                <span className="text-white font-bold" data-id="element-238">
                  + Kit Cartera Activa (Upsell)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-239">
                <Check className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-240" />
                <span className="text-white/90 font-medium" data-id="element-241">
                  Soporte prioritario por email
                </span>
              </li>
            </ul>

            <a href="https://librofy-store.myshopify.com/checkouts/cn/hWNDC2YhgQFxT6QjxhxL0tCE/es-ar?_r=AQABaMWEh2_MnS_qSPgGn5hiRubNit4fMT9glsLEWa7PKZs&cart_link_id=Sy4dIPgn&preview_theme_id=160306823389" className="w-full py-4 rounded-xl font-bold text-white bg-brand-accent hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-center block" data-id="element-242">
              Quiero el sistema completo
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}